import React from 'react';
import { SaleType } from 'modules/desking';
import { SwitchField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { DealBuilderDesking } from './DealBuilderDesking';
import { DealBuilderFormValues, StepComponentProps } from '../../../types';

export const FinanceMenuStep = ({ navigationNode }: StepComponentProps) => {
  const { control, setValue } = useFormContext<DealBuilderFormValues>();

  return (
    <CardContainer
      title="Finance & Menu"
      subTitle="Configure finance programs, rates, and build the customer payment menu."
      actionBtn={
        <SwitchField
          label="Enabled"
          control={control}
          name="financeMenu.isEnabled"
          extraAction={nextValue => {
            if (!nextValue) {
              setValue('financeMenu.saleType', SaleType.Financing);
            }
          }}
        />
      }
    >
      <DealBuilderDesking navigationNode={navigationNode} />
    </CardContainer>
  );
};
